// extracted by mini-css-extract-plugin
module.exports = {"count":"ProfileMerchReview_count__SJCD0"};